export default __webpack_public_path__ + "static/media/nu-bank.4c45b048.svg";